import '../App.css';
import '../assets/styles/requestWord.css';
import { addData, fetchDocument } from '../assets/dataUploader';
import React, {useState} from 'react';

const RequestWordPage = () => {
    const [formData, setFormData] = useState({
        yorubaWord: '',
        englishWord: '',
        partOfSpeech: '',
        sentence: '',
        topic: '',
        customTopic: '',
        audioFile: null
    });

    const sendFormData = async (data) => {
        const date = new Date();
        // Use custom topic if "Other" is selected
        const finalTopic = data.topic === 'Other' ? data.customTopic : data.topic;
        const submissionData = {
            ...data,
            topic: finalTopic
        };
        await addData("glossary_requests", date.toISOString() + "_" + data.englishWord + "_" + data.yorubaWord, submissionData);
    };

    // Send audioBlob to Flask backend
    const sendAudioToBackend = async () => {
        if (!formData.audioFile) return;
        try {
            const formDataToSend = new FormData();
            formDataToSend.append('audio', formData.audioFile);
            formDataToSend.append('yorubaWord', formData.yorubaWord);
            formDataToSend.append('englishWord', formData.englishWord);
            formDataToSend.append('partOfSpeech', formData.partOfSpeech);
            formDataToSend.append('sentence', formData.sentence);
            formDataToSend.append('topic', formData.topic);
            formDataToSend.append('customTopic', formData.customTopic);

            const response = await fetch("https://yorubadictionary.yale.edu/api/upload_request", {
                method: 'POST', 
                body: formDataToSend,
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    const handleInputChange = (e) => {
        const { name, value, files } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: files ? files[0] : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // TODO: Implement form submission logic
        console.log('Form submitted:', formData);
        const datacopy = {...formData};

        if (datacopy.audioFile) {
            await sendAudioToBackend();
            // Call backend to send audio
        }
        // Send details to database
        datacopy.audioFile = null;
        console.log(formData);
        await sendFormData(datacopy);
    };

    return (
        <div className="Home">
            <header className="App-header">
                <h3 style={{textAlign:"center", marginBottom: "0em"}}>Didn't Find A Word? Request It Below!</h3>
                
                <form onSubmit={handleSubmit} className="request-form">

                    <div className="inline-form-input">
                        <div className='form-block'>
                        <label className="form-label">
                            Word in Yoruba:
                        </label>
                        <input
                            type="text"
                            name="yorubaWord"
                            value={formData.yorubaWord}
                            onChange={handleInputChange}
                            required
                            className="form-input"
                        />
                        </div>
                   
                        <div className='form-block'>
                        <label className="form-label">
                            Word in English:
                        </label>
                        <input
                            type="text"
                            name="englishWord"
                            value={formData.englishWord}
                            onChange={handleInputChange}
                            required
                            className="form-input"
                        />
                        </div>
                    </div>

                    <div className="form-group">
                        <label className="form-label">
                            Part of Speech:
                        </label>
                        <select
                            name="partOfSpeech"
                            value={formData.partOfSpeech}
                            onChange={handleInputChange}
                            required
                            className="form-select"
                        >
                            <option value="">Select part of speech</option>
                            <option value="noun">Noun</option>
                            <option value="verb">Verb</option>
                            <option value="adjective">Adjective</option>
                            <option value="adverb">Adverb</option>
                            <option value="pronoun">Pronoun</option>
                            <option value="preposition">Preposition</option>
                            <option value="conjunction">Conjunction</option>
                            <option value="interjection">Interjection</option>
                        </select>
                    </div>

                    <div className="form-group">
                        <label className="form-label">
                            Topic / Category:
                        </label>
                        <select
                            name="topic"
                            value={formData.topic}
                            onChange={handleInputChange}
                            required
                            className="form-select"
                        >
                            <option value="">Select a category</option>
                            <option value="Animals">Animals</option>
                            <option value="Food">Food</option>
                            <option value="Actions">Actions</option>
                            <option value="Parts">Body Parts</option>
                            <option value="Descriptors">Descriptors</option>
                            <option value="Greetings">Greetings</option>
                            <option value="Objects">Classroom and Household Objects</option>
                            <option value="Travel">Travel and Directions</option>
                            <option value="Pronouns">Pronouns</option>
                            <option value="Names">Names</option>
                            <option value="Other">Other</option>
                        </select>
                        {formData.topic === 'Other' && (
                            <input
                                type="text"
                                name="customTopic"
                                value={formData.customTopic}
                                onChange={handleInputChange}
                                placeholder="Enter your custom topic"
                                required
                                className="form-input"
                                style={{ marginTop: '10px' }}
                            />
                        )}
                    </div>

                    <div className="form-group">
                        <label className="form-label">
                            Word in a Sentence:
                        </label>
                        <textarea
                            name="sentence"
                            value={formData.sentence}
                            onChange={handleInputChange}
                            required
                            className="form-textarea"
                        />
                    </div>

                    <div className="form-group">
                        <label className="form-label">
                            Yoruba Pronunciation (Optional, WAV file):
                        </label>
                        <input
                            type="file"
                            name="audioFile"
                            onChange={handleInputChange}
                            accept=".wav"
                            className="form-file-input"
                        />
                    </div>

                    <button
                        type="submit"
                        className="submit-button"
                    >
                        Submit Request
                    </button>
                </form>
            </header>
        </div>
    );
};

export default RequestWordPage;
